import { render, staticRenderFns } from "./guangdongTemp.vue?vue&type=template&id=59207113&scoped=true"
import script from "./guangdongTemp.vue?vue&type=script&lang=js"
export * from "./guangdongTemp.vue?vue&type=script&lang=js"
import style0 from "./guangdongTemp.vue?vue&type=style&index=0&id=59207113&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59207113",
  null
  
)

export default component.exports